import { api } from './api'

export interface ChangePasswordRequest {
  current_password: string
  new_password: string
  new_password_confirmation: string
}

export interface ChangePasswordResponse {
  message: string
  success: boolean
}

export const passwordService = {
  /**
   * Change user password
   */
  async changePassword(data: ChangePasswordRequest): Promise<ChangePasswordResponse> {
    try {
      const response = await api.put('/user/password', data)
      return response.data
    } catch (error: any) {
      console.error('Failed to change password:', error)
      if (error.response?.data?.detail) {
        throw new Error(error.response.data.detail)
      }
      throw new Error('Failed to change password')
    }
  },

  /**
   * Request password reset email
   */
  async forgotPassword(email: string): Promise<{ message: string }> {
    try {
      const response = await api.post('/password', {
        user: { email }
      })
      return response.data
    } catch (error: any) {
      console.error('Failed to send password reset email:', error)
      if (error.response?.data?.detail) {
        throw new Error(error.response.data.detail)
      }
      throw new Error('Failed to send password reset email')
    }
  },

  /**
   * Reset password with token
   */
  async resetPassword(token: string, password: string, passwordConfirmation: string): Promise<{ message: string }> {
    try {
      const response = await api.put('/password', {
        user: {
          password,
          password_confirmation: passwordConfirmation,
          reset_password_token: token
        }
      })
      return response.data
    } catch (error: any) {
      console.error('Failed to reset password:', error)
      if (error.response?.data?.errors?.reset_password_token) {
        throw new Error('Reset token is invalid or expired')
      }
      if (error.response?.data?.detail) {
        throw new Error(error.response.data.detail)
      }
      throw new Error('Failed to reset password')
    }
  }
}